import React, { useRef, useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useNavigate } from 'react-router';
import { getSearchTrackingData } from '../../store/actions/incoming';
import PropTypes from 'prop-types';

const AsyncPackageSearch = (props) => {
    const navigate = useNavigate();
    const { placeHolder, userDetails, isDisabled } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const ref = useRef(null);

    const handleSearch = async (query) => {
        setIsLoading(true);
        let data = {
            pageIndex: 1,
            pageSize: 20,
            sortColumn: "",
            sortOrder: "ASCENDING",
            companySellerId: userDetails.Value.companySellerId,
            isSuperAdmin: userDetails.Value.isSuperAdmin,
            searchKeywords: query.trim(),
        }

        let trackSearchList = await getSearchTrackingData(data);
        if (trackSearchList?.data?.Status === 200) {
            setOptions(trackSearchList.data.EntityList);
            setIsLoading(false);
        }
    };

    // Bypass client-side filtering by returning `true`. Results are already
    // filtered by the search endpoint, so no need to do it again.
    const filterBy = () => true;

    const handleTrackClick = (selectedPackage) => {
        navigate(`/incoming-packages/fd-${selectedPackage.receivedDate}-3pl/${selectedPackage.internalId}`,
            { state: { view: true, isCreated: true, date: selectedPackage.receivedDate } });
    }

    return (
        <AsyncTypeahead
            filterBy={filterBy}
            disabled={isDisabled}
            id="async-example"
            isLoading={isLoading}
            labelKey="trackingNumber"
            minLength={3}
            onSearch={handleSearch}
            options={options}
            placeholder={placeHolder}
            ref={ref}
            onBlur={() => ref.current?.clear()}
            renderMenuItemChildren={(option) => (
                <>
                    <button className='sortBtn' onClick={() => handleTrackClick(option)}>{option.trackingNumber}</button>
                </>
            )}
        />
    );
};

AsyncPackageSearch.propTypes = {
    placeHolder: PropTypes.string.isRequired,
    userDetails: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
}

export default AsyncPackageSearch;